import React, { useEffect, useState } from "react";
import "./style.scss";
import { useDispatch, useSelector } from "react-redux";
import * as faqAction from "../../store/actions/faqAction";
import { faqFeatureKey } from "../../store/featureKeys";
import { useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import VideoAdd from "../AddVideo";
import ImageAdd from "../AddImage";
import { CircularProgress } from "@material-ui/core";

const EditFaq = (props) => {
	const defaultField = { title: "", description: "", image: null, _id: "" };
	const defaultFieldVideoURL = {
		title: "",
		description: "",
		url: "",
		_id: "",
	};
	const { data } = props;

	const dispatch = useDispatch();

	let { article, metaTags, description } = data;

	const { loading, error, faqData } = useSelector((state) => {
		return state[faqFeatureKey];
	});

	let datePublished = data.datePublished.slice(0, 10);

	let [newFaq, setNewFaq] = useState({
		article: article,
		metaTags: metaTags,
		description: description,
		datePublished: datePublished.slice(0, 10),
	});

	// form validation rules
	const validationSchema = Yup.object().shape({
		article: Yup.string().required("Article is required"),
		metaTags: Yup.string().required("Meta Tags is required"),
		description: Yup.string().required("Description is required"),
		datePublished: Yup.date()
			.required("Date is required")
			.typeError("Date is required"),
		pic: Yup.array().of(
			Yup.object().shape({
				title: Yup.string().required("Title is required"),
				_id: Yup.string().required("_id is required"),
				description: Yup.string().required("Description is required"),
				image: Yup.mixed()
					.required("Image is required")
					.test("fileType", "Unsupported file format", (value) => {
						if (!value || !value[0]) return true; // No file selected
						return ["image/jpeg", "image/png", "image/gif"].includes(value[0].type);
					})
					.test("fileSize", "File size is too large", (value) => {
						if (!value || !value[0]) return true; // No file selected
						return value[0].size <= 10485760; // Maximum size: 10MB
					}),
			})
		),
		videoUrls: Yup.array().of(
			Yup.object().shape({
				title: Yup.string().required("Title is required"),
				description: Yup.string().required("Description is required"),
				url: Yup.mixed().required("Video Url is required"),
			})
		),
	});

	const formOptions = { resolver: yupResolver(validationSchema) };
	const [fields, setFields] = useState(data?.pic?.length > 0 ? data.pic : []);
	const [videoUrls, setVideoUrls] = useState(
		data?.video?.length > 0 ? data.video : []
	);

	const {
		register,
		handleSubmit,
		setError,
		getValues,
		reset,
		formState,
		control,
	} = useForm(formOptions);
	const { errors } = formState;
	const { append, remove } = useFieldArray({
		control,
		name: "pic",
	});
	const { append: appendVideoURL, remove: removeVideoURL } = useFieldArray({
		control,
		name: "videoUrls",
	});
	useEffect(() => {
		console.log(data);
		setFields(data?.pic?.length > 0 ? data.pic : []);
		setVideoUrls(data?.video?.length > 0 ? data.video : []);
		setNewFaq({
			article: data.article,
			metaTags: data.metaTags,
			description: data.description,
			datePublished: data.datePublished.slice(0, 10),
		});
		reset();
	}, [data]);
	async function onSubmit(formFields) {
		try {
			const { article, metaTags, description, datePublished, pic, videoUrls } =
				formFields;
			const formData = new FormData();
			formData.append("article", article);
			formData.append("metaTags", metaTags);
			formData.append("description", description);
			formData.append("datePublished", datePublished);
			if (pic && pic.length) {
				for (const image of pic) {
					const {
						_id,
						title,
						description,
						image: [file],
					} = image;
					formData.append("titles[]", title);
					formData.append("descriptions[]", description);
					formData.append("_ids[]", _id);

					if (file) {
						formData.append("imageName[]", file.name);
						formData.append("pic", file);
					} else {
						formData.append("imageName[]", "");
					}
				}
			}
			if (videoUrls && videoUrls.length) {
				for (const item of videoUrls) {
					const { title, description, url } = item;
					formData.append("videoTitles[]", title);
					formData.append("videoDescriptions[]", description);
					formData.append("videoUrl[]", url);
				}
			}
			dispatch(
				faqAction.updateFaq(formData, data._id, () => props.hideForm(), reset)
			);
		} catch (error) {
			console.log(error);
		}
	}

	return (
		<>
			{loading && (
				<div className="zIndexBackdrop">
					<CircularProgress color="inherit" />
				</div>
			)}

			<div className="add-faq-wrapper">
				<form
					className="Faq-form"
					onSubmit={handleSubmit(onSubmit)}
					encType="multipart/form-data">
					<div className="mt-10 flex d-flex justify-content-between">
						<label className="font-18"> Title:</label>
						<button
							type="button"
							className="btn btn-danger"
							onClick={(e) => props.hideForm()}>
							<span>X</span>
						</button>
					</div>
					<div className="input-wrapper">
						<input
							name="article"
							type="text"
							placeholder="Enter Title Here..."
							className="input"
							value={newFaq.article}
							{...register("article", {
								value: newFaq.article,
								onChange: (e) => {
									setNewFaq({ ...newFaq, article: e.target.value });
								},
							})}
						/>
					</div>
					<div className="text-danger text-sm ml-3 pt-1">
						{errors.article?.message}
					</div>
					<div className="mt-10 ">
						<label className="font-18"> Meta tags:</label>
					</div>
					<div className="input-wrapper">
						<input
							name="metaTags"
							type="text"
							placeholder="Enter Meta Tags Here..."
							className="input"
							value={newFaq.metaTags}
							{...register("metaTags", {
								value: newFaq.metaTags,
								onChange: (e) => {
									setNewFaq({ ...newFaq, metaTags: e.target.value });
								},
							})}
						/>
					</div>
					<div className="text-danger text-sm ml-3 pt-1">
						{errors.metaTags?.message}
					</div>
					<div className="mt-10 ">
						<label className="font-18"> Date Published:</label>
					</div>
					<div className="input-wrapper">
						<input
							name="datePublished"
							type="date"
							placeholder="Enter Meta Tags Here"
							className="input"
							value={newFaq.datePublished}
							{...register("datePublished", {
								value: newFaq.datePublished,
								onChange: (e) => {
									setNewFaq({ ...newFaq, datePublished: e.target.value });
								},
							})}
						/>
					</div>
					<div className="text-danger text-xs ml-3 pt-1">
						{errors.datePublished?.message}
					</div>
					<div className="mt-20 ">
						<label className="font-18"> Description:</label>
					</div>
					<div className="">
						<textarea
							className="input p-10"
							placeholder="Article Description and content..."
							rows={4}
							width="100%"
							cols={96}
							value={newFaq.description}
							{...register("description", {
								value: newFaq.description,
								onChange: (e) => {
									setNewFaq({ ...newFaq, description: e.target.value });
								},
							})}></textarea>
					</div>
					<div className="text-danger text-xs ml-3 pt-1">
						{errors.description?.message}
					</div>

					<VideoAdd
						register={register}
						errors={errors}
						defaultFieldVideoURL={defaultFieldVideoURL}
						videoUrls={videoUrls}
						setVideoUrls={setVideoUrls}
						appendVideoURL={appendVideoURL}
						removeVideoURL={removeVideoURL}
						videoRequired={true}
					/>
					{/* upload image multiple times */}
					<ImageAdd
						register={register}
						errors={errors}
						fields={fields}
						append={append}
						remove={remove}
						setFields={setFields}
						defaultField={defaultField}
						imageRequired={false}
					/>
					<div className="save-cancel-wrapper">
						<div>
							<button type="submit" className="btn btn-success">
								<span>Update</span>
							</button>
						</div>
						<div>
							<button
								type="button"
								className="btn btn-danger"
								onClick={(e) => props.hideForm()}>
								<span>CANCEL</span>
							</button>
						</div>
					</div>
				</form>
			</div>
		</>
	);
};

export default EditFaq;
